import { selectBasketIsEmpty, selectBasketIsUnpresentedRentedWarehouses } from 'containers/OrderDetails/basketSlice'
import { selectIsLoggedIn, selectRegistrationData } from './loginSlice'
import SimplifiedSummary from 'containers/OrderDetails/Summary/SimplifiedSummary'
import { useHistory, useLocation } from 'react-router-dom'
import useTranslation from 'hooks/useTranslation'
import { getRedirectPath } from 'utils/redirect'
import { useEffect, useState } from 'react'
import SocialButtons from './SocialButtons'
import { isEmailLogin } from 'utils/login'
import { useSelector } from 'react-redux'
import Form from './Form'
import './style.scss'

const Login = ({ isDesktop = false }) => {
  const [isPassword, showPassword] = useState(false)
  const isUnpresentedRentedWarehouses = useSelector(selectBasketIsUnpresentedRentedWarehouses)
  const registration = useSelector(selectRegistrationData)
  const isBasketEmpty = useSelector(selectBasketIsEmpty)
  const isLogin = useSelector(selectIsLoggedIn)
  const { search } = useLocation()

  const { replace, push } = useHistory()
  const { t } = useTranslation('form')

  const query = new URLSearchParams(search)
  const showMailForm = query.get('mailForm') === '1' || isEmailLogin(query.get('login'))

  useEffect(() => {
    if (isLogin) {
      const redirect = getRedirectPath()
      replace(
        registration
          ? '/registration'
          : isBasketEmpty
            ? isUnpresentedRentedWarehouses
              ? '/newwarehouse'
              : (redirect || '/dashboard')
            : '/order/billing'
      )
    }
  }, [isLogin, isBasketEmpty, replace, registration, isUnpresentedRentedWarehouses])

  return (
    <>
      <div className='login'>
        <div className='login__title title'>
          <div>{t(isPassword ? 'logIn' : 'itsNiceToSeeYou')}</div>
        </div>

        <div className='center'>
          <div className='login__main'>
            <Form
              isPassword={isPassword}
              showPassword={showPassword}
              showMailForm={showMailForm}
              setMailForm={isMail => {
                replace(isMail ? '/login?mailForm=1' : '/login')
              }}
              showRegistrationForm={() => {
                push('/registration')
              }}
            />

            <div className='login__or'>
              <hr />
              <p>{t('or')}</p>
              <hr />
            </div>

            <div className='login__options'>
              {showMailForm
                ? <button
                  className='button--social'
                  onClick={() => {
                    replace('/login')
                  }}>
                  <i className='icon icon--phone' />
                  <span>{t('continueWithPhoneNumber')}</span>
                </button>
                : <button
                  className='button--social'
                  onClick={() => {
                    replace('/login?mailForm=1')
                  }}>
                  <i className='icon icon--mail' />
                  <span>{t('continueWithEmail')}</span>
                </button>}
              <SocialButtons />
            </div>
          </div>
        </div>
      </div>

      {isDesktop && !isBasketEmpty && <div className='orderInfo__aside'>
        <SimplifiedSummary />
      </div>}
    </>
  )
}

export default Login